// SanitizedLink.jsx
import React, { useMemo, forwardRef, startTransition } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { LOCATION_CHANGE } from 'redux-first-history';
import { useDispatch } from 'react-redux';

import getToObject from '../resource/getToObject.js';

const createKey = () => {
  return Math.random().toString(36).substr(2, 8);
};

export const SanitizedLink = forwardRef(
  ({ to: propsTo = '', replace, state, onClick, ...restProps }, ref) => {
    const dispatch = useDispatch();

    const to = useMemo(
      () => getToObject({ to: propsTo, shouldFilterSearch: true }),
      [propsTo]
    );
    return (
      <Link
        ref={ref}
        to={to}
        {...restProps}
        onClick={event => {
          // the `Link` only trigger the navigation. we need to sync the location data to redux store.
          startTransition(() => {
            dispatch({
              type: LOCATION_CHANGE,
              payload: {
                location: { ...to, state, key: createKey() },
                action: replace ? 'REPLACE' : 'PUSH',
              },
            });
          });
          onClick?.(event);
        }}
      />
    );
  }
);

SanitizedLink.displayName = 'SanitizedLink';

SanitizedLink.propTypes = {
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  replace: PropTypes.bool,
  state: PropTypes.object,
  onClick: PropTypes.func,
};

export default SanitizedLink;
